<template>
  <CDropdown placement="bottom- end" autoClose="outside" v-model:visible="visible" >
    <CDropdownToggle :caret="false" :custom="false" class="bg-white border-0 p-0">
      <div class="tw-p-1 !tw-cursor-pointer tw-mb-1" @click.stop="toggleDropdown">
        <base-icon v-if="Object.keys(data).length > 0 && Object.values(data).some(x => !!x)" icon="filter-bold" class="tw-text-primary-500"/>
        <base-icon v-else icon="filter" />
      </div>
    </CDropdownToggle>
    <transition name="dropdown" >
      <CDropdownMenu class="!tw-p-3 tw-translate-y-8">

        <form @submit.prevent="apply" ref="form">
          <template v-for="input in inputs">
            <input-ayandeh v-if="input.type === 'number'"
                           v-model:value="data[input.name]"
                           :label="input.label"
                           label-class="!tw-mb-1"
                           :class="[
                             'te-mb-3',
                             input.direction === 'ltr' ? 'ltr tw-text-left' : 'tw-text-right',
                           ]"
                           :placeholder="input.placeholder"/>

            <input-ayandeh v-else-if="input.type === 'amount'"
                           v-model:value="data[input.name]"
                           :label="input.label"
                           label-class="!tw-mb-1"
                           :number-format="true"
                           :class="[
                             'te-mb-3',
                             input.direction === 'ltr' ? 'ltr tw-text-left' : 'tw-text-right',
                           ]"
                           :placeholder="input.placeholder"/>

            <base-date-picker
              v-else-if="input.type === 'date'"
              :title="input.label"
              :range="true"
              v-model="data[input.name]"
              class="tw-mb-6" />


            <v-select
              v-else-if="input.type === 'select'"
              v-model="data[input.name]"
              :options="input.options"
              :reduce="(option) => option.value"
              :placeholder="input.placeholder"
              :dir="input.direction || 'rtl'"
            ></v-select>

            <select-users v-else-if="input.type === 'user'"
                          :title="input.label"
                          :placeholder="input.placeholder"
                          icon="person"
                          v-model="data[input.name]" />


            <base-select v-else-if="input.type === 'city'"
                         title="محل تخلیه"
                         placeholder="انتخاب محل تخلیه"
                         :search_able="true"
                         :search_in_front="false"
                         :float-title="true"
                         :loading="loadingGetCities"
                         v-model="data[input.name]"
                         :options="cities"
                         :can-load-more="hasNextPageCities"
                         @loadMore="loadMoreCities"
                         icon="distance"/>


            <plate v-else-if="input.type === 'plate'" v-model:plate="data[input.name]" default_letter="" />

          </template>
        </form>

        <div class="tw-flex tw-items-center tw-justify-between tw-mt-8 tw-gap-6">
          <new-btn variant="outline"
                   color="primary"
                   size="sm"
                   @click="removeFilter">
            حذف فیلتر
          </new-btn>
          <new-btn variant="fill"
                   color="primary"
                   size="sm"
                   @click="apply">
            <base-icon icon="check-circle" size="20" class="tw-ml-2 tw-align-middle" />
            اعمال
          </new-btn>
        </div>
      </CDropdownMenu>
    </transition>
  </CDropdown>
</template>

<script setup>

import {ref, watch, defineEmits, onMounted} from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import InputDate from "@/components/inputs/InputDate.vue";
import Plate from '@/components/partial/Plate'
import BaseDatePicker from "@/components/base/select/BaseDatePicker.vue";
import SelectUsers from "@/components/base/select/SelectUsers.vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";

import { getCities, loadMoreCities, hasNextPageCities, cities, loadingGetCities }  from '@/services/city/Cities'


const visible = ref(false);
const input_value = ref('');
const data = ref(() => {});
const form = ref(null);
const emit = defineEmits(['applyFilter', 'update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },
  inputs: {
    type: Array,
    default: () => []
  }
});

onMounted(() => {
  setDefData()

  props.inputs.some(input => input.type === 'city') && getCities()

})

function setDefData() {
  // if (data.value.plate) {
  //   const plateData = data.value.plate;
  //   // delete data.value.plate;
  //   if(plateData) {
  //     data = {
  //       ...data,
  //       ...plateData,
  //     };
  //   } else {
  //     filter_values.value.number_base = null;
  //     filter_values.value.three_digits = null;
  //     filter_values.value.two_digits = null;
  //     filter_values.value.letter = null;
  //   }
  // }


  data.value = props.inputs.reduce((acc, curr) => {
    acc[curr.name] = null;
    return acc;
  }, {})
}
function hide() {
  if(visible.value) {
    visible.value = false
  }
}

function toggleDropdown(e) {
  e.stopPropagation()
  visible.value = !visible.value
}


function removeFilter() {
  setDefData()
  emit('applyFilter', data.value);
  hide()
}

// قلگ برای تشخیص اینکه مقدار فیلتر از داخل تغییر داشته یا از کامپوننت فرزند
const internalUpdate = ref(false)
function apply() {
  internalUpdate.value = true
  emit('applyFilter', data.value);
  hide()
}

watch(() => visible.value, (newVal) => {
  // When Open
  visible
});


watch(
  () => props.inputs,
  (newVal) => {
    if(internalUpdate.value) {
      internalUpdate.value = false
    } else {
      newVal.forEach(input => {
        if('filter_values' in input) {
          data.value[input.name] = input.filter_values[input.name]
        }
      })
    }
  });

// watch(
//   () => props.modelValue,
//   (val) => {
//     data.value = { ...val }
//   },
//   { immediate: true, deep: true }
// )
</script>


<style scoped>
/* dropdown transition */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(1.5rem);
}
</style>
